<template>
  <div class="carousel">
    <a-carousel dotsClass="ant-carousel-dots" autoplay>
      <div
        v-for="(item, index) in data"
        :key="index"
        class="carousel-box">
        <img
          class="carousel-img"
          :src="resourcePath + item"
        />
      </div>
    </a-carousel>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
    data: {
      type: Array,
      default: () => [],
    },
    error: {
      type: Error,
      default: null,
    },
  },
}
</script>

<style lang="less" scoped>
  @import url('~assets/styles/vars.less');
  
  .carousel {
    width: 100%;
    &-box {
      width: 100%;
      height: 457px;
      display: flex !important;
      justify-content: center;
      align-items: center;
      background-color: #ffffff;
      overflow: hidden;
    }
    /deep/.slick-slide img {
      height: 100%;
    }
  }
</style>
